import { NOTICE_STATUS } from '../AnnouncementList/announcement';

export enum ActionTypeEnum {
  related = 1,
  unrelated = 2
}

export enum RecordSceneEnum {
  sales = 5
}

export const NOTICE_SUCCESS_ARR = [
  NOTICE_STATUS.Confirmed,
  NOTICE_STATUS.Uncorrelated,
  NOTICE_STATUS.Repetition
];

export const NOTICE_REVERT_ARR = [
  NOTICE_STATUS.Uncorrelated,
  NOTICE_STATUS.Repetition
];

export interface AnnouncementDetailDataInterface {
  id: number;
  eventId: number | null;
  infoId: number | null;
  noticeCode: string;
  noticeType: string;
  noticeTypeValue: string;
  customerCompany: string;
  noticeName: string;
  sectorType: number;
  sectorTypeValue: string;
  customerCompanyType: number;
  customerCompanyTypeName: string;
  industryKey: number | null;
  industryName: string | null;
  productLineKey: string;
  productLineName: string;
  tenderBudget: number | null;
  tenderBudgetCurrency: number;
  publishTime: string | null;
  publishTimeFull: string | null;
  tenderOpenTime: string | null;
  tenderOpenTimeFull: string | null;
  tenderDealer: string | null;
  provinceCode: string;
  provinceName: string;
  cityCode: string;
  cityName: string;
  successfulCompany: string;
  successfulPrice: number | null;
  successfulPriceCurrency: number;
  successfulPriceCurrencyValue: string;
  successfulPriceRemark: string | null;
  tenderOrgContacts: string | null;
  tenderOrgContactsMobile: string | null;
  currentProcessorUserId: string;
  currentProcessorUserName: string;
  noticeLink: string;
  importType: string;
  importTypeValue: string;
  subjectMatterName: string;
  subjectMatterBrand: string;
  subjectMatterModel: string;
  subjectMatterTotalNumber: number;
  noticeStatus: number;
  noticeStatusValue: string;
  confirmResultStatus: number;
  confirmResultStatusValue: string;
  noticeSource: number;
  remark: string | null;
  deleteStatus: number;
  createUserId: string;
  createUserName: string;
  updateUserId: string;
  createTime: string;
  updateTime: string;
  createTimeFull: string;
  updateTimeFull: string;
  updateUserName: string;
  subjectMatter: AnnouncementSubjectMatterItemInterface[];
  currentProcessorUserPhone: string;
  currentProcessorUserEmail: string;
  applicationDirectionKey: string | null;
  applicationDirectionName: string | null;
  vendorAccount: string;
  vendorPwd: string;
  groups: AnnouncementGroupsItemInterface[];
  projects: string | null;
  applicationDirectionSecondKey: string | null;
  applicationDirectionSecondName: string | null;
  projectName: string | null;
  overdue: number | null;
  estimatedPurchaseTime: string | null;
  estimatedPurchaseTimeFull: string | null;
  tenderBudgetCurrencyValue: string | null;
  isFirst: boolean | null;
  customerCompanySecondType: number | null;
  customerCompanySecondTypeName: string | null;
  dataFlag: number | undefined;
  infoTitle: string | null;
  corpId: string | null;
  unrelatedReason: string | null;
  unrelatedReasonValue: string | null;
  projectBrandKeyStr: string | null;
  projectBrandValueStr: string | null;
  projectModelKeyStr: string | null;
  projectModelValueStr: string | null;
  projectProductLineKeyStr: string | null;
  projectProductLineKeyNameStr: string | null;
  totalAmount: number | null;
  totalAmountCurrencyValue: string | null;
  lerStatus: number | null;
  oppId: string | null;
}

export interface AnnouncementSubjectMatterItemInterface {
  noticeCode: string;
  subjectMatterCode: string;
  subjectMatterName: string;
  subjectMatterBrand: string | null;
  subjectMatterModel: string | null;
  importType: string | null;
  importTypeValue: string | null;
  subjectMatterPrice: number | null;
  subjectMatterCurrency: number;
  subjectMatterCurrencyValue: string;
  subjectMatterNumber: number;
  totalAmount: number | null;
  totalAmountCurrency: number;
  totalAmountCurrencyValue: string;
  successfulCompany: string | null;
  majorDispositions: string | null;
  subjectMatterStatus: number;
  subjectMatterStatusValue: string;
  subjectMatterRemark: string | null;
  repetitionProjectCode: string | null;
  deleteStatus: number;
  createUserId: string;
  createUserName: string;
  updateUserId: string;
  createTime: string;
  updateTime: string | null;
  updateUserName: string;
  productLineKey: number;
  productLineName: string;
  estimatedPurchaseTime: string | null;
  estimatedPurchaseTimeFull: string | null;
  subjectMatterBrandKey: string | null;
  unrelatedReason: string | null;
  unrelatedReasonValue: string | null;
}

export interface AnnouncementGroupsItemInterface {
  eventId: string | null;
  groupCode: string;
  groupName: string;
  noticeCode: string | null;
  noticeType: string | null;
  noticeTypeValue: string | null;
  noticeStatus: number | null;
  noticeStatusValue: string | null;
  publishTime: string | null;
  currentNotice: boolean | null;
  relationStatus: boolean | null;
  notices: GroupsNoticeItemInterface[];
  noticeName: string | null;
  subjectMatterNames: string[] | null;
  subjectMatterBrand: string | null;
  productLineName: string | null;
  [key: string]: any;
}

export interface GroupsNoticeItemInterface {
  eventId: string | null;
  groupCode: string | null;
  groupName: string | null;
  noticeCode: string;
  noticeType: string;
  noticeTypeValue: string;
  noticeStatus: number;
  noticeStatusValue: string;
  publishTime: string | null;
  currentNotice: boolean;
  relationStatus: boolean | null;
  notices: null;
  noticeName: string;
  subjectMatterNames: string[] | null;
  subjectMatterBrand: string | null;
  productLineName: string | null;
}

export interface RelationProjectInterface {
  noticeCode: string;
  subjectMatterCode: string;
  subjectMatterName: string;
  subjectMatterBrand: string;
  subjectMatterModel: string;
  importType: string;
  importTypeValue: string;
  subjectMatterPrice: string;
  subjectMatterCurrency: string;
  subjectMatterCurrencyValue: string;
  subjectMatterNumber: string;
  totalAmount: string;
  totalAmountCurrency: string;
  totalAmountCurrencyValue: string;
  successfulCompany: string;
  majorDispositions: string;
  subjectMatterStatus: string;
  subjectMatterStatusValue: string;
  subjectMatterRemark: string;
  repetitionProjectCode: string;
  deleteStatus: number;
  createUserId: string;
  createUserName: string;
  updateUserId: string;
  createTime: string;
  updateTime: string;
  updateUserName: string;
  productLineKey: string;
  productLineName: string;
  estimatedPurchaseTime: string;
  estimatedPurchaseTimeFull: string;
  subjectMatterBrandKey: string;
  unrelatedReason: string;
  unrelatedReasonValue: string;
  technicalParameters: string;
  statusAi: string;
  statusValueAi: string;
  productLineAi: string;
  brandAi: string;
  modelAi: string;
  classTypeAi: string;
  classTypeValueAi: string;
  evidenceAi: string;
  reasoningAi: string;
  id: number;
  baseNoticeCode: string;
  baseSubjectMatterCode: string;
  noticeProjectCode: string;
  subjectMatterProjectCode: string;
  projectName: string;
  coverageStatus: number;
  opportunityStatus: number;
  oppId: string;
  attendTenderStatus: string;
  prosNumStatus: string;
  loseWinStatus: string;
  coreLoseReasonStatus: string;
  oldCustomerStatus: string;
  oldCustomerModel: string;
  projectProductLineKey: string;
  projectProductLineValue: string;
  subjectMatterProjectSaleId: string;
  subjectMatterProjectSaleName: string;
  subjectMatterProjectStatus: number;
  subjectMatterProjectStatusValue: string;
  subjectMatterProjectRemark: string;
  subjectMatterProjectName: string;
  projectProductLineKeyStr: string;
  projectProductLineValueStr: string;
  projectBrandKeyStr: string;
  projectBrandValueStr: string;
}
